var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlock = function SvgBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    fillRule: "evenodd",
    d: "M3 12c0-4.968 4.032-9 9-9s9 4.032 9 9-4.032 9-9 9-9-4.032-9-9zm3.255 4.334A7.16 7.16 0 0 1 4.8 12c0-3.969 3.231-7.2 7.2-7.2a7.16 7.16 0 0 1 4.334 1.455l-10.08 10.08zm1.577 1.534A7.166 7.166 0 0 0 12 19.2c3.969 0 7.2-3.231 7.2-7.2 0-1.552-.494-2.99-1.332-4.168L7.832 17.868z",
    clipRule: "evenodd"
  })));
};
export default SvgBlock;